














import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";

@Component({})
export default class DataGrid extends Vue {
  @Prop({ default: true, type: Boolean }) hasBorder;
  @Prop({ default: false, type: Boolean }) hasTopMargin18;
  @Prop({ default: true, type: Boolean }) hasBottomMargin24;
  @Prop({ default: true, type: Boolean }) isViewMode;

  private rowArr = [];
  private formInline = {
    user: "",
    region: ""
  };
  get getmarginBottom24() {
    return this.hasBottomMargin24 ? "marginB" : "";
  }
}
